import { lazy } from "react";

export { SETTINGS_MENU_PATH } from "./path";
export const SettingsMenuPage = lazy(() => import("./page"));
